module.exports = "/_next/static/images/PayNYC-72cd2dbdc45d499991c1b74a18a1cb1e.png";